(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/tooltip-widget/assets/javascripts/tooltip-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/tooltip-widget/assets/javascripts/tooltip-widget.js');
"use strict";

function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _args = new WeakMap();

class TooltipWidget extends HTMLElement {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _args, void 0);
  }
  get args() {
    return _classPrivateFieldGet(_args, this);
  }
  set args(value) {
    _classPrivateFieldSet(_args, this, value);
  }
  connectedCallback() {
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    if (!this.args) {
      return;
    }
    const _JSON$parse = JSON.parse(this.args),
      text = _JSON$parse.text;
    const css = "\n      .tooltip {\n        margin: 0 auto;\n        width: 100%;\n        max-width: 250px;\n        padding: 12px;\n        font-style: italic;\n        background-color: #C80000;\n        color: white;\n        border-radius: 4px;\n        position: relative;\n        text-align: center;\n        word-wrap: break-word;\n      }\n\n      /* The small triangle */\n      .tooltip::after {\n        content: \"\";\n        position: absolute;\n        bottom: -15px;\n        left: 62%;\n        transform: translateX(-50%);\n        border-width: 14px 13px 4px 0px;\n        border-style: solid;\n        border-color: #C80000 transparent transparent transparent;\n      }\n    ";
    shadowRoot.innerHTML = "\n      <style>".concat(css, "</style>\n      <div class=\"tooltip\">\n        ").concat(text, "\n      </div>\n   ");
  }
}
customElements.define('tooltip-widget', TooltipWidget);

 })(window);